// extracted by mini-css-extract-plugin
export var actionButton = "_aj-1";
export var actionButtons = "_aj-2";
export var actions = "_aj-0";
export var aiUnread = "_aj-10";
export var alignCenter = "_aj-h";
export var backWrapper = "_aj-3";
export var cellContainer = "_aj-4";
export var checkboxContainer = "_aj-5";
export var contentContainer = "_aj-6";
export var contentHeader = "_aj-8";
export var conversationsTableWrapper = "_aj-s";
export var draftReplyBadgeContainer = "_aj-m";
export var dropdownItem = "_aj-b";
export var dropdownItemsContainer = "_aj-a";
export var dropdownTitle = "_aj-c";
export var errorIcon = "_aj-7";
export var filter = "_aj-d";
export var gray = "_aj-i";
export var headerActionButtons = "_aj-e";
export var headerCheckboxContainer = "_aj-f";
export var icon = "_aj-j";
export var menuContainer = "_aj-k";
export var noMoreTicketsIcon = "_aj-12";
export var noMoreTicketsSubText = "_aj-13";
export var oneLine = "_aj-l";
export var optionsButton = "_aj-n";
export var plus = "_aj-o";
export var portalButtonsWrapper = "_aj-g";
export var red = "_aj-p";
export var scrolledTop = "_aj-9";
export var search = "_aj-q";
export var selectedConversationsCount = "_aj-r";
export var spinner = "_aj-t";
export var strong = "_aj-u";
export var summaryCell = "_aj-v";
export var tableContainer = "_aj-11";
export var tagContainer = "_aj-w";
export var threeDots = "_aj-x";
export var twoLines = "_aj-y";
export var unread = "_aj-z";